import { Text } from '@leroy-merlin-br/backyard-react'
import {
  ChevronDoubleDownOutline,
  ChevronDoubleUpOutline
} from '@backyard-ui/icons'

import * as S from './styled'

const HOME_DELIVERY = 'Entrega em domicílio'
const SERVICE = 'Serviços'
const PICKUP = 'Clique e retire'
const SMART_CHECKOUT = 'Retirada na Loja'

const HOME_DELIVERY_SHIFT_LABEL = 'Turno'
const PICKUP_SHIFT_LABEL = 'Horário'

const SHIPPING_LABEL = {
  [HOME_DELIVERY]: 'Data entrega',
  [SERVICE]: 'Previsão de realização',
  [PICKUP]: 'Data entrega',
  [SMART_CHECKOUT]: 'Data entrega'
}

const FORECAST_LABEL = {
  SERVICE: '3 dias após a entrega',
  STANDALONE_SERVICE: '3 dias úteis'
}

const Shift = props => {
  if (!props.type) {
    return
  }

  const shiftLabel =
    props.type === HOME_DELIVERY
      ? HOME_DELIVERY_SHIFT_LABEL
      : PICKUP_SHIFT_LABEL

  return (
    <div className="title-shift color-default">
      <div className="small">{shiftLabel}</div>
      <strong>{props.shift}</strong>
    </div>
  )
}

const ShippingInfo = (type, date, isStandaloneService) => {
  const serviceType =
    type === SERVICE && (isStandaloneService ? 'STANDALONE_SERVICE' : 'SERVICE')

  return {
    label: SHIPPING_LABEL[type],
    forecast: FORECAST_LABEL[serviceType] || date
  }
}

const Title = ({
  type,
  quantity,
  deliveryDate,
  shift,
  isStandaloneService,
  isOpen = false
}) => {
  const Chevron = isOpen ? ChevronDoubleUpOutline : ChevronDoubleDownOutline

  const { label, forecast } = ShippingInfo(type, deliveryDate?.date, isStandaloneService)

  return (
    <S.Wrapper>
      <S.Type className="color-primary">
        <Text as="strong" size="mega" isBold noMargin>
          {type}
        </Text>
      </S.Type>

      <S.Quantity className="color-default">
        <Text size="kilo" noMargin>
          Itens
        </Text>
        <Text as="strong" size="kilo" isBold noMargin>
          {quantity}
        </Text>
      </S.Quantity>

      <S.Shipping className="color-default">
        <Text size="kilo" noMargin>
          {label}
        </Text>
        <Text as="strong" size="kilo" isBold noMargin>
          {forecast}
        </Text>
      </S.Shipping>

      {shift && <Shift {...{ type, shift }} />}

      <S.Button className="color-primary">
        <Chevron width={16} height={16} fill="currentColor" />
      </S.Button>
    </S.Wrapper>
  )
}

export default Title
